module.exports = __webpack_public_path__ + "static/other/rocket_repair.6afa90bf.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/rocket_repair.json
// module id = 2433
// module chunks = 0